import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { compose } from 'redux';

import { Button, Checkbox } from '@pearsontechnology/aero-components';

import { featureKeys } from 'services/FeatureFlagService';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { ModalActions } from 'components/Modal';

import messages from './messages';
import {
  AddModalWrapper,
  OutputTypeItem,
  ModalTitle,
} from './styles';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';


function PublishMarketSelect({ onDismiss, markets, setSelectedMarket }) {
  const [marketSelected, setMarketSelected] = useState(null);

  const onNext = () => {
    setSelectedMarket(marketSelected.conditional);
  };

  const selectMarket = (market) => {
    setMarketSelected(market);
  };

  const checkBoxes = markets.map((item, i) =>
    <OutputTypeItem key={i}>
      <Checkbox
        label={item.conditional}
        rounded
        checked={marketSelected?.conditional === item?.conditional}
        onChange={() => selectMarket(item)}
      />
    </OutputTypeItem>);

  return (
    <AddModalWrapper>
      <ModalTitle>{intl.formatMessage(messages.marketSelectTitle)}</ModalTitle>
      {checkBoxes}
      <ModalActions>
        <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
        <Button disabled={!marketSelected} primary onClick={onNext}>{intl.formatMessage(messages.nextButton)}</Button>
      </ModalActions>
    </AddModalWrapper>
  );
}

PublishMarketSelect.propTypes = {
  onDismiss: PropTypes.func,
  markets: PropTypes.array,
  setSelectedMarket: PropTypes.func,
};

const flagNames = [
  featureKeys.WORKSPACE_PUBLICATIONS_INDESIGN,
];

export default compose(withTheme, enhanceWithFeatureFlagSubscription)(PublishMarketSelect, flagNames);
